// import { Paper } from '@mui/material';
import { Box } from '@mui/system';
// import avatar6 from 'assets/images/avatar/avatar_6.webp';
import GedaCheckList from 'components/SS/gedaCheckList';

// import Ownership from 'components/sections/account/users-permissions/Ownership';

function GedaManagment() {
  return (
    <>
      <div>
        {/* <Paper sx={{ flex: 1, p: { xs: 3, md: 5 } }}>
          <Ownership
            name="Tsamina Mina"
            email="tsaminamina@email.com"
            avatar={avatar6}
            lastLoginAt="2024-11-15 15:54"
          />
        </Paper> */}
        <Box>
          <GedaCheckList />
        </Box>
      </div>
    </>
  );
}

export default GedaManagment;
